export default "__VITE_ASSET__BXkGjWST__"